import { Pipe, PipeTransform } from '@angular/core';
import { CreateIrrigationType, IrrigationType } from '@app/irrigations/models/models';

/**
 * Transforms irrigation type to a translation key.
 * The translation key is used to display the irrigation type in the UI.
 */
@Pipe({ name: 'irrigationType' })
export class IrrigationTypePipe implements PipeTransform {
  transform(type: IrrigationType | CreateIrrigationType): string {
    const keys: Record<IrrigationType, string> = {
      Sprinkler: 'irrigation.sprinkler',
      Drip: 'irrigation.drip',
      Flooding: 'irrigation.flooding',
      Unknown: 'irrigation.unknown',
    };
    return keys[type] ?? 'irrigation.unknown';
  }
}
